module.exports = __webpack_public_path__ + "static/media/toptal.28d96f80.svg";